const clubs = state => state.clubs;

const clubsLoading = state => state.clubsLoading;

const colleges = state => state.colleges;

const countries = state => state.countries;

const collegesLoading = state => state.collegesLoading;

const states = state => state.states;

const statesLoading = state => state.statesLoading;

const collegeGpas = state => state.collegeGpas;

const collegeGpasLoading = state => state.collegeGpasLoading;

const academicSpecialities = state => state.academicSpecialities;

const academicSpecialitiesLoading = state => state.academicSpecialitiesLoading;

const divisions = state => state.divisions;

const divisionsLoading = state => state.divisionsLoading;

const collegeStates = state => state.collegeStates;

const collegeStatesLoading = state => state.collegeStatesLoading;

const schoolTypes = state => state.schoolTypes;

const schoolTypesLoading = state => state.schoolTypesLoading;

const educationTypes = state => state.educationTypes;

const educationTypesLoading = state => state.educationTypesLoading;

const collegeSettings = state => state.collegeSettings;

const collegeSettingsLoading = state => state.collegeSettingsLoading;

const ageGroups = state => state.ageGroups;

const ageGroupsLoading = state => state.ageGroupsLoading;

const playerPositions = state => state.playerPositions;

const playerPositionsLoading = state => state.playerPositionsLoading;

const playerStates = state => state.playerStates;

const playerStatesLoading = state => state.playerStatesLoading;

const throwingHands = state => state.throwingHands;

const battingHands = state => state.battingHands;

const clubEventTypes = state => state.clubEventTypes;

const clubEventTypesLoading = state => state.clubEventTypesLoading;

const collegeEventTypes = state => state.collegeEventTypes;

const collegeEventTypesLoading = state => state.collegeEventTypesLoading;

export default {
  clubs,
  clubsLoading,
  countries,
  colleges,
  collegesLoading,
  states,
  statesLoading,
  collegeGpas,
  collegeGpasLoading,
  academicSpecialities,
  academicSpecialitiesLoading,
  divisions,
  divisionsLoading,
  collegeStates,
  collegeStatesLoading,
  schoolTypes,
  schoolTypesLoading,
  educationTypes,
  educationTypesLoading,
  collegeSettings,
  collegeSettingsLoading,
  ageGroups,
  ageGroupsLoading,
  playerPositions,
  playerPositionsLoading,
  playerStates,
  playerStatesLoading,
  battingHands,
  throwingHands,
  clubEventTypes,
  clubEventTypesLoading,
  collegeEventTypes,
  collegeEventTypesLoading
};
